import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Waves from "./waves";
import { grid } from "../constants";

const WaveAnimation = ({
  frequency,
  duration,
  origin,
  opacity,
  color,
  expand,
}) => {
  const n = Math.round(Math.max(1, duration / frequency));

  return (
    <>
      <div className="anim-container" data-cy="Ecosystem Animation">
        {Array(n)
          .fill()
          .map((a, i) => (
            <Waves
              i={i}
              color={color}
              expand={expand}
              duration={duration}
              frequency={frequency}
              origin={origin.r}
              key={`wave-${i}`}
            />
          ))}
      </div>
      <style jsx>{`.anim-container {
  position: absolute;
  width: ${100 * expand}%;
  height: ${100 * expand}%;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}`}</style>
    </>
  );
};

export default React.memo(WaveAnimation);

WaveAnimation.propTypes = {
  /**
   * {
   *  "info": "Número de ondas producidas por segundo",
   *  "kind": "both",
   *  "beautifulName": "Frecuencia de produccíon de ondas"
   * }
   */
  frequency: PropTypes.number,

  /**
   * {
   *  "info": "Velocidad a la que se desplaza la onda",
   *  "kind": "both",
   *  "beautifulName": "Velocidad de desplazamiento"
   * }
   */
  velocity: PropTypes.number,

  /**
   * {
   *  "info": "Objeto con las coordenadas iniciales y radio inical de las ondas",
   *  "kind": "both",
   *  "beautifulName": "Condiciones iniciales"
   * }
   */
  origin: PropTypes.shape({
    x0: PropTypes.number,
    y0: PropTypes.number,
    r: PropTypes.number,
  }),

  /**
   * {
   *  "info": "Booleano que indica si se ha de producir más ondas",
   *  "kind": "both",
   *  "beautifulName": "Producir ondas"
   * }
   */
  produce: PropTypes.bool,

  /**
   * {
   *  "info": "Resolución del canvas",
   *  "kind": "both",
   *  "beautifulName": "Resolución de canvas"
   * }
   */
  resolution: PropTypes.number,
  /**
   * {
   *  "info": "Color de la onda",
   *  "kind": "both",
   *  "beautifulName": "Resolución de canvas"
   * }
   */
  color: PropTypes.string,

  /**
   * {
   *  "info": "Función",
   *  "kind": "both",
   *  "beautifulName": "Resolución de canvas"
   * }
   */
  timingFunction: PropTypes.func,

  opacity: PropTypes.number,
};

WaveAnimation.defaultProps = {
  frequency: 2000,
  duration: 10000,
  origin: { x0: 500, y0: 500, r: 128 },
  produce: true,
  resolution: 1000,
  color: "#FFFFFF",
  timingFunction: (x) => x,
  opacity: 0.7,
};
